import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";
import {
	InputCheckboxMaster,
	InputOptionMaster,
	InputTextMaster,
	LabelRequired,
	MasterButton,
	TableAction,
	TableWrapper,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { TYPE_INSTANCE2 } from "App/constants";
import { useDatatables, useSelectOption } from "App/hooks";
import {
	defaultToastError,
	defaultToastSuccess,
	isNull,
} from "App/utils/helpers";
import {
	headCellsAlamat,
	selectAlamatOrganisasi,
	STATE_ALAMAT,
	useCity,
	useDistrict,
	useSubDistrict,
} from "../helpers";

export default function OrganisasiAlamat({
	formDataAlamat,
	setFormDataAlamat,
	alamat,
	setAlamat,
}) {
	const listProv = useSelectOption(
		true,
		"/alamat/list_propinsi_prm",
		TYPE_INSTANCE2
	);

	const handleChange = (text) => (e) => {
		setFormDataAlamat({
			...formDataAlamat,
			[text]: e.target.value,
		});
	};

	const {
		page,
		setQ,
		setPage,
		setRowsPerPage,
		data,
		order,
		orderBy,
		handleRequestSort,
		length,
		rowsPerPage,
	} = useDatatables({
		rows: alamat,
		orderByDefault: "line",
		orderByRow: ["line"],
		defaultOrder: "asc",
	});

	const handleAddAlamat = (e) => {
		e.preventDefault();
		console.log("Hasilnya :", alamat);
		if (isNull(formDataAlamat.type)) {
			defaultToastError("Kategori Alamat Organisasi Belum Di Isi");
		} else if (isNull(formDataAlamat.province)) {
			defaultToastError("Provinsi Belum Di Isi");
		} else if (isNull(formDataAlamat.city)) {
			defaultToastError("Kota Belum Di Isi");
		} else if (isNull(formDataAlamat.district)) {
			defaultToastError("Kecamatan Belum Di Isi");
		} else if (isNull(formDataAlamat.sub_district)) {
			defaultToastError("Kelurahan Belum Di Isi");
		} else if (isNull(formDataAlamat.line)) {
			defaultToastError("Alamat Lengkap Belum Di Isi");
		} else if (isNull(formDataAlamat.postalCode)) {
			defaultToastError("Kode POS Belum Di Isi");
		} else {
			const checkAlamat = alamat.filter(
				(x) => x.line[0] === formDataAlamat.line
			);
			if (checkAlamat.length > 0) {
				defaultToastError("Data Sudah Ada !, Silahkan ganti alamat lengkap");
			} else {
				setAlamat([
					...alamat,
					{
						use: "work",
						type: formDataAlamat.type,
						line: [formDataAlamat.line],
						city: formDataAlamat.city_name,
						postalCode: formDataAlamat.postalCode,
						country: "ID",
						extension: [
							{
								url: "https://fhir.kemkes.go.id/r4/StructureDefinition/administrativeCode",
								extension: [
									{
										url: formDataAlamat.province_name,
										valueCode: formDataAlamat.province.toString(),
									},
									{
										url: formDataAlamat.city_name,
										valueCode: formDataAlamat.city,
									},
									{
										url: formDataAlamat.district_name,
										valueCode: formDataAlamat.district,
									},
									{
										url: formDataAlamat.sub_district_name,
										valueCode: formDataAlamat.sub_district,
									},
								],
							},
						],
					},
				]);
				setFormDataAlamat({
					...STATE_ALAMAT,
					available: true,
				});
			}
		}
	};

	const handleDeleteAlamat = (row) => {
		const dataAlamat = alamat.filter((x) => x.line[0] !== row?.line[0]);
		setAlamat(dataAlamat);
	};

	return (
		<>
			<Paper className="p-1 mb-1">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<h4>ALAMAT ORGANISASI</h4>
					<InputCheckboxMaster
						checked={formDataAlamat.available}
						name="availableAlamat"
						id="availableAlamat"
						label="Punya Alamat Organisasi ?"
						onChange={() =>
							setFormDataAlamat({
								...formDataAlamat,
								available: !formDataAlamat.available,
							})
						}
					/>
				</div>

				<form
					onSubmit={(e) => handleAddAlamat(e)}
					style={{
						display: formDataAlamat.available === false ? "none" : "",
					}}
				>
					<div className="mb-1">
						<Grid container spacing={1}>
							<Grid item md={3}>
								<InputOptionMaster
									name="type"
									label={<LabelRequired label="Kategori Alamat Lokasi" />}
									id="type"
									withSearch={false}
									data={selectAlamatOrganisasi}
									value={formDataAlamat.type}
									needParse={false}
									onChange={handleChange("type")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="provinsi"
									label={<LabelRequired label="Provinsi" />}
									id="provinsi"
									value={formDataAlamat.province}
									withSearch={true}
									labelValue={formDataAlamat.province_name}
									onChange={(e) => {
										setFormDataAlamat({
											...formDataAlamat,
											province: e?.value,
											province_name: e?.label,
											city: null,
											city_name: "Pilih Kota",
											district: null,
											district_name: "Pilih Kecamatan",
											sub_district: null,
											sub_district_name: "Pilih Kelurahan",
										});
									}}
									data={listProv}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="kota"
									label={<LabelRequired label="Kota" />}
									id="kota"
									needParse={false}
									value={formDataAlamat.city}
									withSearch={true}
									labelValue={formDataAlamat.city_name}
									onChange={(e) => {
										setFormDataAlamat({
											...formDataAlamat,
											city: e?.value,
											city_name: e?.label,
											district: null,
											district_name: "Pilih Kecamatan",
											sub_district: null,
											sub_district_name: "Pilih Kelurahan",
										});
									}}
									data={useCity(formDataAlamat.province)}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="dictrict"
									label={<LabelRequired label="Kecamatan" />}
									id="dictrict"
									needParse={false}
									value={formDataAlamat.district}
									withSearch={true}
									labelValue={formDataAlamat.district_name}
									onChange={(e) => {
										setFormDataAlamat({
											...formDataAlamat,
											district: e?.value,
											district_name: e?.label,
											sub_district: null,
											sub_district_name: "Pilih Kelurahan",
										});
									}}
									data={useDistrict(formDataAlamat.city)}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="sub_district"
									label={<LabelRequired label="Kelurahan" />}
									id="sub_district"
									needParse={false}
									value={formDataAlamat.sub_district}
									withSearch={true}
									labelValue={formDataAlamat.sub_district_name}
									onChange={(e) => {
										setFormDataAlamat({
											...formDataAlamat,
											sub_district: e?.value,
											sub_district_name: e?.label,
										});
									}}
									data={useSubDistrict(formDataAlamat.district)}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="line"
									label={<LabelRequired label="Alamat Lengkap" />}
									id="line"
									placeholder="Alamat Lengkap"
									value={formDataAlamat.line}
									onChange={handleChange("line")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="postalCode"
									label={<LabelRequired label="Kode POS" />}
									id="postalCode"
									placeholder="Kode POS"
									value={formDataAlamat.postalCode}
									onChange={handleChange("postalCode")}
								/>
							</Grid>
							<Grid item md={3} style={{ paddingTop: "31px" }}>
								<MasterButton
									outline={false}
									type={"submit"}
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "center",
									}}
									color="green"
									name={"TAMBAH"}
									size="md"
								/>
							</Grid>
						</Grid>
					</div>
					<div
						style={{
							marginLeft: "6px",
						}}
					>
						<Grid item md={12}>
							<TableWrapper
								title="Daftar Alamat Yang Terdaftar"
								setQ={setQ}
								withAddButton={false}
								withExportButton={false}
								order={order}
								orderBy={orderBy}
								handleRequestSort={handleRequestSort}
								length={length}
								rows={alamat}
								headCells={headCellsAlamat}
								page={page}
								setPage={setPage}
								rowsPerPage={rowsPerPage}
								setRowsPerPage={setRowsPerPage}
							>
								{stableSort(data, getComparator(order, orderBy))
									.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
									.map((row, index) => {
										return (
											<TableRow
												hover
												tabIndex={-1}
												key={index}
												style={{
													backgroundColor:
														index % 2 === 0 ? "transparent" : "#fff",
												}}
											>
												<TableCell
													component="th"
													scope="row"
													padding="none"
													width="5%"
													align="center"
												>
													{index + 1}
												</TableCell>
												<TableCell align="center">
													<TableAction
														clickDelete={() => handleDeleteAlamat(row)}
														isUpdate={false}
													/>
												</TableCell>
												<TableCell align="left">
													{isNull(row?.line[0]) ? "-" : row?.line[0]}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.postalCode) ? "-" : row?.postalCode}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.extension[0].extension[0].url)
														? "-"
														: row?.extension[0].extension[0].url}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.extension[0].extension[1].url)
														? "-"
														: row?.extension[0].extension[1].url}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.extension[0].extension[2].url)
														? "-"
														: row?.extension[0].extension[2].url}
												</TableCell>
												<TableCell align="left">
													{isNull(row?.extension[0].extension[3].url)
														? "-"
														: row?.extension[0].extension[3].url}
												</TableCell>
											</TableRow>
										);
									})}
							</TableWrapper>
						</Grid>
					</div>
				</form>
			</Paper>
		</>
	);
}
